module.exports = __webpack_public_path__ + "static/img/3.8dc2809.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/2/zh/3.png
// module id = kzG+
// module chunks = 0